import React from 'react';
import { Checkbox, Tooltip, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text, Title } = Typography;

export default function EvaluationChecklist({ title, items, checkedItems, onChange, disabled }) {
    const handleCheckChange = (itemId, text, checked) => {
        const updatedItems = checkedItems.map((item) => {
            // Support both new criterionId and legacy indicatorId/confirmationId
            if (
                item.criterionId?.toString() === itemId?.toString() ||
                item.indicatorId?.toString() === itemId?.toString() ||
                item.confirmationId?.toString() === itemId?.toString()
            ) {
                return { ...item, checked };
            }
            return item;
        });

        // If item doesn't exist in checkedItems, add it
        const itemExists = checkedItems.some(
            (item) =>
                item.criterionId?.toString() === itemId?.toString() ||
                item.indicatorId?.toString() === itemId?.toString() ||
                item.confirmationId?.toString() === itemId?.toString()
        );

        if (!itemExists) {
            updatedItems.push({
                criterionId: itemId,
                text,
                checked
            });
        }

        onChange(updatedItems);
    };

    const isItemChecked = (itemId) => {
        const item = checkedItems.find(
            (i) =>
                i.criterionId?.toString() === itemId?.toString() ||
                i.indicatorId?.toString() === itemId?.toString() ||
                i.confirmationId?.toString() === itemId?.toString()
        );
        return item ? item.checked : false;
    };

    // Don't render if no items - parent component will handle visibility
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <div className="evaluation-checklist">
            <Title level={5}>{title}</Title>
            <div className="checklist-items">
                {items.map((item) => (
                    <div key={item._id} className="checklist-item">
                        <Checkbox
                            checked={isItemChecked(item._id)}
                            onChange={(e) =>
                                handleCheckChange(item._id, item.text, e.target.checked)
                            }
                            disabled={disabled}
                        >
                            <Tooltip title={item.text}>
                                <Text
                                    ellipsis={{ tooltip: false }}
                                    style={{ maxWidth: '100%', display: 'block' }}
                                >
                                    {item.text}
                                </Text>
                            </Tooltip>
                        </Checkbox>
                    </div>
                ))}
            </div>
        </div>
    );
}

EvaluationChecklist.propTypes = {
    title: PropTypes.string.isRequired,
    fieldKey: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
            text: PropTypes.string.isRequired
        })
    ),
    checkedItems: PropTypes.arrayOf(
        PropTypes.shape({
            criterionId: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            indicatorId: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            confirmationId: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            text: PropTypes.string,
            checked: PropTypes.bool
        })
    ),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

EvaluationChecklist.defaultProps = {
    items: [],
    checkedItems: [],
    disabled: false,
    fieldKey: ''
};
